const TEXTS = {
  ALT: 'Error image',
  DESCRIPTION:
    'Something went wrong\n Please, refresh the page or try again later.',
};

export { TEXTS };
